import React, { useEffect, useState } from 'react';
import './EventsPageTable.css'
import { supabase } from '../../supabase';

import Edit from '../../Assets/Icons/Edit.svg'
import Delete from '../../Assets/Icons/Delete.svg'

const UsersPageTable = () => {
    const [users, setUsers] = useState([]);

    useEffect(()=>{
            const getUsers = async () => {
                const res = await supabase.from('Users').select('*')
                setUsers(res.data)
            }
    
            getUsers();
        } , [])

        const deleteEvent = async (id) => {
                const res = await supabase.from('Users').delete().eq('id', id)
                console.log(res);
            }

    return ( 
        <div className='EventsPageTable'>
            <p className='TableName'>All Users</p>
            
                        <table>
                            <tr className='TopRow'>
                                <th>
                                    User
                                </th>
                                <th>
                                    Email
                                </th>
                                <th>
                                    Role
                                </th>
                                <th>
                                    Join Date
                                </th>
                                <th>
                                    Actions
                                </th>
                            </tr>
                            {
                                users.map((item)=>{
                                    return <tr>
                                        <td>
                                            {item.user_Name}
                                        </td>
                                        <td>
                                            {item.user_Email}
                                        </td>
                                        <p className={item.role}>
                                                {item.role}
                                            </p>
                                        <td>
                                            {item.created_at}
                                        </td>
                                        <td className='Actions'>
                                            <img className='Edit' src={Edit} alt="" />
                                            <img onClick={() => deleteEvent(item.id)} className='Delete' src={Delete} alt="" />
                                        </td>
                                    </tr>
                                })
                            }
                        </table>
        </div>
     );
}
 
export default UsersPageTable;